"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.woBadChar = exports.hasBadChar = void 0;
var badChar = " (),.:/!?_'`0123456789";
exports.hasBadChar = function (s) {
    for (var _i = 0, _a = s.split(''); _i < _a.length; _i++) {
        var c = _a[_i];
        if (badChar.indexOf(c) !== -1)
            return true;
    }
    return false;
};
exports.woBadChar = function (s) {
    if (!s)
        return '';
    var result = '';
    for (var _i = 0, _a = s.split(''); _i < _a.length; _i++) {
        var c = _a[_i];
        if (badChar.indexOf(c) === -1)
            result += c;
    }
    return result;
};
